import joinParts from "assets/scripts/utils/joinParts";
export function showAuthorized(deceased) {
    return deceased;
}
export function showRelationship(deceased) {
    return deceased;
}
export function getDecedentName(decedent) {
    return (decedent != null && joinParts(decedent.firstName, decedent.lastName)) || "(Name Unknown)";
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/Registration/registrationUtils.ts